module.exports = "/images/watsons.png?2f328bdfea377f9f7020e30d466571fc";